export const marketSelector = ({markets}) => markets